import type { Mission } from '../missions.ts'

export const bea: Mission = {
  id: "bea",
  name: "Bureau of Economic Analysis",
  short: "BEA",
  call: "Economics",
  kind: "subagency",
  parent: "doc",
  url: "https://www.bea.gov/",
  palette: {
    primary: "#004990",
    secondary: "#333333",
    accent: "#d59f0f",
  },
  colorSource: {
    kind: "site",
    url: "https://www.bea.gov/",
  },
  motif: "chart",
  mission: {
    text: "The Bureau of Economic Analysis (BEA) promotes a better understanding of the U.S. economy by providing the most timely, relevant, and accurate economic accounts data in an objective and cost-effective manner.",
    url: "https://www.bea.gov/about/who-we-are",
  },
  fact: {
    text: "The Department of Commerce recognized GDP, the cornerstone of BEA's national accounts, as its greatest achievement of the 20th century.",
    url: "https://www.bea.gov/about/who-we-are",
  },
  logo: {
    file: "public/logos/bea.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-BureauOfEconomicAnalysis-Logo.svg",
  },
  identifier: {
    about: "https://www.bea.gov/about/who-we-are",
    accessibility: "https://www.bea.gov/about/policies-and-information/accessibility",
    oig: "https://www.oig.doc.gov/",
    performance: "https://www.bea.gov/about/budget-and-performance",
    privacy: "https://www.bea.gov/about/policies-and-information/privacy",
  },
  media: {
    photos: [
      {
        file: "/media/bea-freight-train.jpg",
        small: "/media/bea-freight-train-sm.jpg",
        alt: "Orange freight locomotives pull a long line of loaded cars across open grassland under a sky of scattered white clouds.",
        title: "Freight train near Avondale, Pueblo County, Colorado, May 25, 2015",
        creator: "Carol M. Highsmith",
        source: "https://commons.wikimedia.org/wiki/File:A_long,_passing_freight_train_near_Avondale_in_rural_Pueblo_County,_Colorado_LCCN2015632763.tif",
        license: "Public domain (Carol M. Highsmith Archive, Library of Congress)",
      },
    ],
  },
}
